module.exports = __webpack_public_path__ + "img/logo_blue_yili.e1ea640.png";